import React, { useCallback, useEffect, useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  Button,
  Modal,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Tooltip,
} from '@mui/material';
import { PlayArrow, MoreVert } from '@mui/icons-material';
import live from 'packages/novous_web/src/assets/icons/Live.svg';
import call from 'packages/novous_web/src/assets/icons/phone-calling.svg';
import clone from 'packages/novous_web/src/assets/icons/Clone.svg';
import reverse from 'packages/novous_web/src/assets/icons/Fast Backward.svg';
import map from 'packages/novous_web/src/assets/icons/Map Stroke.svg';
import share from 'packages/novous_web/src/assets/icons/Share.svg';
import add from 'packages/novous_web/src/assets/icons/add.svg';
import eye from 'packages/novous_web/src/assets/icons/Eye.svg';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import comment from 'packages/novous_web/src/assets/icons/Comment.svg';
import useAxios from 'packages/novous_web/src/api/useAxios';
import { API_ENDPOINTS } from 'packages/novous_web/src/api/endpoints';
import AlertToast from '../../../../../common/components/Alert';
import LiveFeedModal from '../../../Reports/components/LiveFeed';
import CustomIconButton from 'packages/novous_web/src/common/components/CustomIconButton';
import ShareFootageModal from 'packages/novous_web/src/common/components/ShareFootageModal';
import axiosInstance from '../../../../../api/apiClient';
import useApiError from 'packages/novous_web/src/api/useApiError';

interface Alert {
  id: string;
  driverName: string;
  vehicleNumber: string;
  device_id: string;
  vehicleId: string;
  date_time: string;
  vehicleName: string;
  warningSortKey: string;
  videoUrls: string[];
  warningType: string;
  warningString: string;
  driverId: string;
  videoFileName: string;
  gpsSpeed: number;
  deviceType?: string;
  tripId: string;
}

interface AlertsGridProps {
  alerts: Alert[];
}

const dateTimeStyles = {
  fontFamily: '"Inter Tight", sans-serif',
  fontWeight: 400,
  fontSize: '12px',
  lineHeight: '18px',
  letterSpacing: '0%',
  color: '#767676',
};

const NON_VIDEO_ALERTS = [
  "Continuous Driving",
  "Night Driving",
  "Geo Fence Alert",
  "Geofence Out Duration Exceeded",
  "Geofence Overspeed Violation",
]

const AlertsGrid: React.FC<AlertsGridProps> = ({ alerts }) => {
  const navigate = useNavigate();
  console.log('alerts', alerts);
  const [alertOpen, setAlertOpen] = useState<boolean>(false);
  const [alertMessage, setAlertMessage] = useState<string>('');
  const [alertType, setAlertType] = useState<'error' | 'success' | 'warning' | 'info'>('error');
  const [isLiveFeedOpen, setIsLiveFeedOpen] = useState({
    isOpen: false,
    tripId: '',
    vehicleId: '',
    deviceId: '',
    warningSortKey: '',
    deviceType: '',
  });
  const [liveFeedCameraInfo, setLiveFeedCameraInfo] = useState<any[]>([]);
  const [driverDialogOpen, setDriverDialogOpen] = useState<any>();
  const { data, error, loading, fetchData } = useAxios<any>(
    API_ENDPOINTS.alarm.VEHICLE_ALERT_COMMENT,
    'POST',
  );

  const [selected, setSelected] = useState(2);
  const handleLiveFeedClose = () => {
    setIsLiveFeedOpen({
      isOpen: false,
      tripId: '',
      vehicleId: '',
      deviceId: '',
      warningSortKey: '',
      deviceType: '',
    });
    setSelected(2);
  };
  const [openEmailModal, setOpenEmailModal] = useState(false);
  const [isCheckingVideos, setIsCheckingVideos] = useState(false);
  const handleOpenLiveFeed = async (
    vehicleId: string,
    videoUrls: string[],
    warningSortKey: string,
    warningType: string,
    videoFileName: string,
    deviceId: string,
    cameraKey?: string,
    deviceType?: string,
    alertobj?: Alert,
  ) => {
    if (NON_VIDEO_ALERTS.includes(warningType)) {
      setAlertMessage('No video available for this alert');
      setAlertType('warning');
      setAlertOpen(true);
      return;
    }

    setIsLiveFeedOpen({
      isOpen: true,
      tripId: alertobj?.tripId || '', // <-- Use tripId from alertobj
      vehicleId: vehicleId,
      deviceId: deviceId,
      warningSortKey: warningSortKey,
      deviceType: deviceType || '',
    });
    console.log('videoUrls', videoUrls);
    setIsCheckingVideos(true); // Start checking

    if (!videoFileName) {
      console.log('No video file name available');
      setLiveFeedCameraInfo([]);
      setIsCheckingVideos(false);
      return;
    }

    try {
      const response = await axiosInstance({
        url: API_ENDPOINTS.alarm.ALERTS_VIDE0_URL_SECONDARY,
        method: 'POST',
        data: {
          vehicleId: vehicleId,
          timestamp: warningSortKey.split('#')[1],
          alertType: warningType,
          fileNames: videoFileName,
        },
        responseType: 'json',
      });

      console.log('newVideoURLS', response.data.data);

      const videoUrlsFromApi = Array.isArray(response.data.data) ? response.data.data : [];

      const cameraInfo = videoUrlsFromApi.map((url: string) => {
        const fileName = url.split('/').pop()?.split('?')[0] || '';
        const segments = fileName.split('_');
        const cameraCode = segments[1] || 'Unknown';
        const cameraMapping: Record<string, string> = {
          '01': 'ADAS',
          '02': 'CAM3',
          '03': 'CAM4',
          '04': 'DMS',
        };
        const arr = Object.entries(cameraMapping);
        const ck =
          cameraKey === 'FCW'
            ? 'ADAS'
            : cameraKey === 'DSM'
              ? 'CAM3'
              : cameraKey === 'REAR_CAMERA'
                ? 'CAM4'
                : cameraKey === 'IN_CABIN'
                  ? 'DMS'
                  : cameraKey;

        const cameraName = cameraMapping[cameraCode] || 'Unknown';
        //  const cameraId = cameraMapping[cameraCode] || "Unknown";
        return { cameraId: cameraCode, cameraName, playBackUrl: url };
      });

      setLiveFeedCameraInfo(cameraInfo);
      setSelected(0);
    } catch (error) {
      console.error('Error fetching video URLs:', error);
      setLiveFeedCameraInfo([]);
      setIsCheckingVideos(false);
    }
  };
  const [alert, setSelectedAlert] = useState<Alert | null>(null);

  const handleTripReconstruction = useCallback(() => {
    if (alert?.tripId) {
      // Use absolute path to ensure correct navigation
      navigate(`/trips/reconstruction/${alert.tripId}`);
      console.log('Navigating to trip reconstruction:', alert.tripId);
    }
  }, [alert, navigate]);

  console.log(isLiveFeedOpen, 'isLiveFeedOpen');

  const redirectToDriverHistory = () => {
    console.log('alert', alert);
    if (!alert?.driverId || alert?.driverId === 'NA') {
      setDriverDialogOpen(true);
      console.log('No driver associated with this alert');
      return;
    } else {
      navigate(`/directories/drivers/${alert?.driverId}`);
    }
  };

  const viewMenuData = [
    {
      name: 'View Details',
      icon: eye,
      click: () => navigate('/alarm/vehicle-alert-details', { state: alert }),
    },
    {
      name: 'Driver History',
      icon: call,
      click: () => {
        redirectToDriverHistory();
      },
    },
    { name: 'Trip Reconstruction', icon: reverse, click: handleTripReconstruction },
    {
      name: 'Share Alert',
      icon: share,
      click: () => {
        setOpenEmailModal(true);
        setAnchorEl(null);
      },
    },
  ];
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [modalOpen, setModalOpen] = useState(false);
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  const [alertComment, setAlertComment] = useState<string>('');
  const handleOpenMenu = (event: React.MouseEvent<HTMLSpanElement>, alert: any) => {
    setAnchorEl(event.currentTarget);
    setSelectedAlert(alert);
  };
  const handleClose = () => {
    setModalOpen(false);
  };
  const handleCommentModalOpen = (alert: any) => {
    setSelectedAlert(alert);
    console.log('alert', alert);
    if (alert?.comment) {
      setAlertComment(alert?.comment);
    }
    setModalOpen(true);
  };
  const formatTimestamp = (timestamp: string) => {
    console.log('timestamp', timestamp);
    const [year, month, day, hour, minute, second] = timestamp?.split('_');
    const date = new Date(`${year}-${month}-${day}T${hour}:${minute}:${second}`);
    return date
      .toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true,
      })
      .replace(',', '');
  };
  const saveComment = () => {
    fetchData({
      deviceId: alert?.device_id,
      comment: alertComment,
      sortKey: alert?.warningSortKey,
    });
    setModalOpen(false);
  };
  useEffect(() => {
    if (data?.status === 200) {
      setAlertMessage('Comment added successfully');
      setAlertType('success');
      setAlertOpen(true);
    }
  }, [data]);
  const handleShareClose = () => {
    setOpenEmailModal(false);
  };
  useEffect(() => {
    if (data?.status === 200) {
      setAlertMessage('Comment added successfully');
      setAlertType('success');
      setAlertOpen(true);
    }
  }, [data]);

  const driverDialogClose = () => {
    setDriverDialogOpen(false);
  };

  return (
    <Box className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 w-full overflow-hidden">
      {alerts.slice(0, 4).map(
        (alert) => (
          (
            <Card
              key={alert.id}
              sx={{
                minWidth: { xs: 'auto', md: 'auto' },
                maxWidth: { xs: '100%', md: 375.5 },
                width: { xs: '100%', md: 'auto' },
                minHeight: 85,
                borderRadius: '12px',
                border: '1px solid #F0EFF8',
                boxShadow: 'none',
                '&:hover': { boxShadow: 3 },
                overflow: 'hidden',
              }}
              className="transition-shadow"
            >
              <CardContent sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: '4px', minWidth: 0, overflow: 'hidden' }}>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-start',
                    width: '100%',
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Tooltip title={`DRI${alert.vehicleId.slice(-4)}`} arrow>
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontWeight: 500,
                          fontSize: '1rem',
                          maxWidth: '100px',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                        }}
                      >
                        {`DRI${alert.vehicleId.slice(-4)}`}
                      </Typography>
                    </Tooltip>
                    <img
                      src={comment}
                      alt="comment"
                      style={{ width: 20, height: 20, cursor: 'pointer' }}
                      onClick={() => handleCommentModalOpen(alert)}
                    />
                  </Box>
                  <Box sx={{ display: 'flex', gap: 1, opacity: NON_VIDEO_ALERTS.includes(alert.warningString) ? 0.5 : 1 }}>
                    <IconButton
                      size="small"
                      sx={{ color: '#5547DD', p: 0 }}
                      onClick={() =>
                        handleOpenLiveFeed(
                          alert.vehicleId,
                          alert.videoUrls,
                          alert.warningSortKey,
                          alert.warningString,
                          alert.videoFileName,
                          alert.device_id,
                          alert.deviceType,
                          alert.deviceType,
                          alert,
                        )
                      }
                    >
                      <PlayArrow fontSize="medium" />
                    </IconButton>
                    <IconButton size="small" onClick={(event) => handleOpenMenu(event, alert)} sx={{ p: 0 }}>
                      <MoreVert fontSize="small" />
                    </IconButton>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    width: '100%',
                    flexWrap: { xs: 'wrap', md: 'nowrap' },
                    gap: { xs: 0.5, md: 2 },
                  }}
                >
                  <Typography
                    variant="caption"
                    sx={{
                      color: 'text.secondary',
                      fontSize: { xs: '10px', md: '12px' },
                      minWidth: { xs: 'fit-content', md: 'auto' },
                    }}
                  >
                    {alert.vehicleId}
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{
                      color: 'text.secondary',
                      fontSize: { xs: '10px', md: '12px' },
                      minWidth: { xs: 'fit-content', md: 'auto' },
                    }}
                  >
                    {`${alert.gpsSpeed} Km/h`}
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{
                      ...dateTimeStyles,
                      fontSize: { xs: '10px', md: '12px' },
                      minWidth: { xs: 'fit-content', md: 'auto' },
                    }}
                  >
                    {formatTimestamp(alert?.date_time)}
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          )
        ),
      )}
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseMenu}>
        {viewMenuData.map((item, index) => (
          <MenuItem key={index} onClick={item.click}>
            <div className="flex gap-2 mt-1">
              <img src={item.icon} alt={item.name} style={{ marginRight: 8, width: 20, height: 20 }} />
              <Typography variant="body2" fontWeight={600}>
                {item.name}
              </Typography>
            </div>
          </MenuItem>
        ))}
      </Menu>
      <Modal
        open={modalOpen}
        onClose={handleClose}
        aria-labelledby="add-comment-modal"
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <Box
          sx={{
            width: 560,
            height: 472,
            p: 4,
            borderRadius: '16px',
            border: '1px solid #F0EFF8',
            backgroundColor: 'background.paper',
            display: 'flex',
            flexDirection: 'column',
            gap: 4,
          }}
        >
          {/* Header */}
          <Typography
            variant="h5"
            sx={{
              fontFamily: 'Inter Tight',
              fontWeight: 600,
              fontSize: '24px',
              lineHeight: '36px',
            }}
          >
            Add Comment
          </Typography>

          {/* Description */}
          <Typography
            sx={{
              fontFamily: 'Inter Tight',
              fontWeight: 400,
              fontSize: '16px',
              lineHeight: '24px',
              color: 'text.secondary',
            }}
          >
            Provide additional context or recommendations for this alert. Your comments will be logged for
            future reference and analysis.
          </Typography>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Typography
              sx={{
                fontFamily: 'Inter Tight',
                fontWeight: 'bold',
                fontSize: '16px',
                lineHeight: '24px',
                color: 'text.primary',
              }}
            >
              Comments
            </Typography>
            <TextField
              label="Write here"
              multiline
              rows={4}
              value={alertComment}
              onChange={(e) => setAlertComment(e.target.value)}
              variant="outlined"
              fullWidth
              InputLabelProps={{
                sx: {
                  fontFamily: 'Inter Tight',
                  fontWeight: 400,
                },
              }}
              InputProps={{
                sx: {
                  fontFamily: 'Inter Tight',
                  fontWeight: 400,
                },
              }}
            />
          </Box>

          {/* Buttons */}
          <Box sx={{ display: 'flex', gap: 2, mt: 'auto' }}>
            <Button
              variant="outlined"
              onClick={handleClose}
              sx={{
                fontFamily: 'Inter Tight',
                fontWeight: 500,
                textTransform: 'none',
              }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => saveComment()}
              sx={{
                fontFamily: 'Inter Tight',
                fontWeight: 500,
                textTransform: 'none',
                ml: 'auto',
              }}
            >
              Save
            </Button>
          </Box>
        </Box>
      </Modal>
      <ShareFootageModal
        open={openEmailModal}
        onClose={handleShareClose}
        existingVideos={alert?.videoUrls || []}
        videoFetchConfig={{
          endpoint: API_ENDPOINTS.alarm.ALERTS_VIDE0_URL_SECONDARY,
          method: 'POST',
          payload: {
            vehicleId: alert?.vehicleId,
            timestamp: alert?.warningSortKey?.split('#')[1],
            alertType: alert?.warningString,
            fileNames: alert?.videoFileName,
          },
        }}
        emailConfig={{
          endpoint: API_ENDPOINTS.alarm.SHARE_ALERT_DETAILS_EMAIL,
          payload: {
            deviceId: alert?.device_id,
            warningSortKey: alert?.warningSortKey,
          },
        }}
        onVideoCopied={() => setOpenEmailModal(false)}
        onEmailSent={() => setOpenEmailModal(false)}
      />
      <AlertToast
        message={alertMessage}
        type={alertType}
        open={alertOpen}
        onClose={() => setAlertOpen(false)}
      />
      <LiveFeedModal
        type="alert"
        alertName="Alert Evidence"
        selectedCamera={selected}
        trip={isLiveFeedOpen}
        cameraInfo={liveFeedCameraInfo}
        isDash={true}
        open={isLiveFeedOpen.isOpen}
        onClose={handleLiveFeedClose}
        deviceId={isLiveFeedOpen.deviceId}
        isCheckingVideos={isCheckingVideos}
      />
      <Dialog
        open={driverDialogOpen}
        onClose={driverDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Alert Message</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Driver not associated with this particular alert
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={driverDialogClose} autoFocus>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AlertsGrid;
